// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "card-c4DDr";
var _5 = "card_wide-2ZyO8";
var _6 = "card_inLanding-2R8aH";
var _7 = "image-2q1vT";
var _8 = "body-iWaRJ";
var _9 = "body__inner-2ckAk";
var _a = "title-lQ9e-";
var _b = "text-2_uqH";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "card", _5 as "card_wide", _6 as "card_inLanding", _7 as "image", _8 as "body", _9 as "body__inner", _a as "title", _b as "text" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "card": _4, "card_wide": _5, "card_inLanding": _6, "image": _7, "body": _8, "body__inner": _9, "title": _a, "text": _b }
